export const MAX_QTY = 200;
export const QTY_THRESHOLD = 10;
